var megaItems = document.querySelectorAll('.mega-open');
var megaMenuSubItems = document.querySelectorAll('.desktop--mega-menu-container-item');
var megaMenuSliders = document.querySelectorAll('desktop--mega-menu-container-items');
var megaMenuWrappers = document.querySelectorAll('.desktop--mega-menu-wrapper');
var mobileSubItems = document.querySelectorAll('.mobile-sub-items');
var mobileProducts = document.querySelectorAll('.mobile--container-items');

function removeActives() {
    for(const megaItem of megaItems) {
        document.getElementById(megaItem.dataset.mega).classList.remove('active');
    }
}

function removeSubItems() {
    for(const megaMenuSubItem of megaMenuSubItems) {
        megaMenuSubItem.classList.remove('active');
    }
}

function removeActiveSliders() {
    for(const slider of megaMenuSliders) {
        slider.classList.remove('active');
    }
}

function resetActive() {
    for(const wrapper of megaMenuWrappers) {
        console.log(wrapper.querySelectorAll('.desktop--mega-menu-container-item')[0]);
        wrapper.querySelectorAll('.desktop--mega-menu-container-item')[0].classList.add('active');
    }
}

for(const megaMenuSubItem of megaMenuSubItems) {
    var activeSub;
    megaMenuSubItem.addEventListener('mouseover', function(){
        removeSubItems();
        megaMenuSubItem.classList.add('active');
        if(activeSub != megaMenuSubItem.dataset.subContainer) {
            activeSub = megaMenuSubItem.dataset.subContainer;
            removeActiveSliders();
            if(document.getElementById(megaMenuSubItem.dataset.subContainer)) {
                document.getElementById(megaMenuSubItem.dataset.subContainer).classList.add('active');
            }
        }
    });
}

function setupMegaMenuToggle() {
    let timeout;
    for(const megaItem of megaItems) {
        megaItem.addEventListener('mouseover', function(){
            clearTimeout(timeout);
            for(const wrapper of megaMenuWrappers) {
                wrapper.classList.remove('active');
            }
            megaItem.nextElementSibling.classList.add('active');
            if(document.getElementById(megaItem.dataset.mega)) {
                document.getElementById(megaItem.dataset.mega).classList.add('active');
            }
        });
        for(const wrapper of megaMenuWrappers) {
            wrapper.addEventListener('mouseenter', () => {
                // Clear any existing timeout while the mouse is on the menu
                clearTimeout(timeout); 
            });
        }
        const hideMenu = () => {
            timeout = setTimeout(() => {
                for(const wrapper of megaMenuWrappers) {
                    wrapper.classList.remove('active');
                    removeSubItems();
                    resetActive();
                }
            }, 100);
        };
        
        megaItem.addEventListener('mouseleave', hideMenu);

        // 2. When the mouse leaves the *menu*
        for(const wrapper of megaMenuWrappers) {
            wrapper.addEventListener('mouseleave', hideMenu);
        }
    }
}

setupMegaMenuToggle();

for(const mobileSubItem of mobileSubItems) {
    mobileSubItem.addEventListener('click', function(e){
        e.preventDefault();
        console.log(mobileSubItem);
        for(const mobileProduct of mobileProducts) {
            mobileProduct.classList.remove('active')
        }
        for(const mobileSubItem of mobileSubItems) {
            mobileSubItem.classList.remove('active')
        }
        mobileSubItem.classList.add('active');
        document.getElementById(mobileSubItem.dataset.mobileContainer).classList.add('active');
    })
}